export const formFields = [
  {
    section: "Benefit Maximum Step Alternate Co-pays",
    name: "bscScheduleName",
    label: "Benefit Max Schedule",
    fieldLabel: "BSC Schedule Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 35],
  },
  {
    section: "Benefit Maximum Step Alternate Co-pays",
    name: "bscDescription",
    label: "Description",
    fieldLabel: "BSC Description",
    type: "text",
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 47],
  },
  {
    section: "Benefit Maximum Step Alternate Co-pays",
    name: "bsdStepNumber",
    label: "Step",
    fieldLabel: "BSD Step Number",
    type: "number",
    fractionDigits: 0,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 11],
  },
  {
    section: "Benefit Maximum Step Alternate Co-pays",
    name: "bmdScheduleCode",
    label: "Benefit Max Drug Status Schedule",
    fieldLabel: "BMD Schedule Code",
    type: "lookup",
    externalProgram: { default: "RCBMD005" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          { source: "bmdScheduleCode", target: "bmdScheduleCode" },
          { source: "bmdDescription", target: "bmdDescription" },
        ],
      },
    },
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: -, Change: Editable, View: Read-only",
    position: [7, 35],
  },
  {
    section: "Benefit Maximum Step Alternate Co-pays",
    name: "bmdDescription",
    label: "",
    fieldLabel: "BMD Description",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [7, 47],
  },

  {
    section: "Table format with below columns",
    format: "columnHeader",
    label: "Generic Indicator",
    type: "label",
    position: [8, 1],
  },
  {
    section: "Table format with below columns",
    format: "columnHeader",
    label: "Non-Preffered",
    type: "label",
    position: [8, 2],
  },

  {
    section: "Table format with below columns",
    format: "columnHeader",
    label: "Preffered",
    type: "label",
    position: [8, 3],
  },

  {
    section: "Table format with below columns",
    Layout: "Table Format",
    label: "'M' Amount",
    type: "label",
    position: [10, 1],
  },

  {
    section: "Table format with below columns",
    name: "bacCopayNonprefMFlt",
    label: "",
    fieldLabel: "BAC Copay NonPref 'M' Flt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [10, 2],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayPrefMFlat",
    label: "",
    fieldLabel: "BAC Copay Pref 'M' Flat",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [10, 3],
  },

  {
    section: "Table format with below columns",
    Layout: "Table Format",
    label: "'M' Percent",
    type: "label",
    position: [11, 1],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayNonprefMPct",
    label: "",
    fieldLabel: "BAC Copay NonPref 'M' Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [11, 2],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayPrefMPercnt",
    label: "",
    fieldLabel: "BAC Copay Pref 'M' Percnt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [11, 3],
  },

  {
    section: "Table format with below columns",
    Layout: "Table Format",
    label: "'N' Amount",
    type: "label",
    position: [12, 1],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayNonprefNFlt",
    label: "",
    fieldLabel: "BAC Copay NonPref 'N' Flt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [12, 2],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayPrefNFlat",
    label: "",
    fieldLabel: "BAC Copay Pref 'N' Flat",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [12, 3],
  },

  {
    section: "Table format with below columns",
    Layout: "Table Format",
    label: "'N' Percent",
    type: "label",
    position: [13, 1],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayNonprefNPct",
    label: "",
    fieldLabel: "BAC Copay NonPref 'N' Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [13, 2],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayPrefNPercnt",
    label: "",
    fieldLabel: "BAC Copay Pref 'N' Percnt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [13, 3],
  },

  {
    section: "Table format with below columns",
    Layout: "Table Format",
    label: "'O' Amount",
    type: "label",
    position: [14, 1],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayNonprefOFlt",
    label: "",
    fieldLabel: "BAC Copay NonPref 'O' Flt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [14, 2],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayPrefOFlat",
    label: "",
    fieldLabel: "BAC Copay Pref 'O' Flat",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [14, 3],
  },

  {
    section: "Table format with below columns",
    Layout: "Table Format",
    label: "'O' Percent",
    type: "label",
    position: [15, 1],
  },

  {
    section: "Table format with below columns",
    name: "bacCopayNonprefOPct",
    label: "",
    fieldLabel: "BAC Copay NonPref 'O' Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [15, 2],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayPrefOPercnt",
    label: "",
    fieldLabel: "BAC Copay Pref 'O' Percnt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [15, 3],
  },

  {
    section: "Table format with below columns",
    Layout: "Table Format",
    label: "'Y' Amount",
    type: "label",
    position: [16, 1],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayNonprefYFlt",
    label: "",
    fieldLabel: "BAC Copay NonPref 'Y' Flt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [16, 2],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayPrefYFlat",
    label: "",
    fieldLabel: "BAC Copay Pref 'Y' Flat",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [16, 3],
  },

  {
    section: "Table format with below columns",
    Layout: "Table Format",
    label: "'Y' Percent",
    type: "label",
    position: [17, 1],
  },

  {
    section: "Table format with below columns",
    name: "bacCopayNonprefYPct",
    label: "",
    fieldLabel: "BAC Copay NonPref 'Y' Pct",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [17, 2],
  },
  {
    section: "Table format with below columns",
    name: "bacCopayPrefYPercnt",
    label: "",
    fieldLabel: "BAC Copay Pref 'Y' Percnt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add -, Change: Editable, View: Read-only",
    position: [17, 3],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "Added",
    type: "date",
    format: "MM/DD/YYYY",
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [22, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "Changed",
    type: "date",
    format: "MM/DD/YYYY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [22, 60],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "User",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [22, 80],
  },
];
